import styled from 'styled-components';

const StylePage = styled.div`
  font-variant-numeric: lining-nums;
  font-feature-settings: 'lnum';
  padding: 0;
  margin: 0;
  background: linear-gradient(
      270deg,
      rgba(255, 182, 86, 0.04) 0%,
      rgba(255, 110, 114, 0.04) 50%,
      rgba(0, 172, 249, 0.04) 100%
    ),
    var(--Background-Default, #fff);
  width: 100%;
  top: 0;
  right: 0;
  left: 0;
  position: absolute;
  overflow-x: hidden;
`;

export default StylePage;
